import ArchiveWinner from './Main'

const route = {
  path: '/archive/winner',
  name: 'winnerArchive',
  meta: {
    title: 'Archive - A D M A N 2 0 1 9'
  },
  component: ArchiveWinner
}

export default route
